<template>
  <!-- 人才政策咨询留言回复 -->
  <div class="page">
    <Spin fix v-if="showPageLoading"></Spin>
    <div v-if="!successShow">

      <div class="topBg">
        <img :showLoading="true" :src="'https://rc.pudong.gov.cn/rcminiappzf/rcfwpt/img/img/title.png'" />
        <div class="info">
          <div class="content">

            <div class="description">
              您好，欢迎您到{{model.deptName}}办理业务。
            </div>
            <div class="description">
              如果您是办理外国人来华工作许可预审退回修改、待受理业务，请确认已在外国人来华工作管理服务系统提交材料。为了加快处理速度，请先输入申请编号【申请编号需输入完整18位或后6位，如果多个请用逗号分开】
            </div>
          </div>
        </div>
      </div>
      <div class="form">

        <div class="cardCenter">

          <div>
            <Form ref="Form" :model="model" :rules="rules" label-position="top" :label-width="0">
              <FormItem prop="applicationNos" ref="item2">
                <Input v-model="model.applicationNos" type="textarea" :rows="4" placeholder="请输入" :maxlength="200" show-word-limit>
                </Input>
              </FormItem>

            </Form>
          </div>
          <div class="btn_">
            <Button type="primary" size="large" long @click="submit()" :style="{background: '#0c3762', color: '#fff'}" color="#0c3762">提交</Button>
          </div>
        </div>
      </div>
      <div class="copy">

        <div class="">
          上海市浦东新区人才服务中心©2015-2025
        </div>
        <div class="">
          沪ICP备11006370号-3
        </div>
        <div class="">
          沪公网安备 31011502000473号
        </div>
      </div>
    </div>

    <div class="success" v-if="successShow">
      <div class="success_content">
        <div class="success_icon">
          <Icon type="ios-checkmark-circle" size="100" color="#52c41a" />
        </div>
        <div class="success_content_title">
          <span>提交成功</span>
        </div>
        <div class="success_content_desc">
          <!-- <span>您的申请编号已成功提交，我们会尽快处理</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseURL: this.$store.state.baseURL,
      captchaImage: '', // 新增验证码图片 base64
      isBind: false,
      showPageLoading: false,
      successShow: false,
      dept: [
        { id: 12, name: '陆家嘴（金融）分中心' },
        { id: 17, name: '人事档案服务部' },
        { id: 30, name: '川沙（度假区）分中心' },
        { id: 31, name: '金桥分中心' },
        { id: 32, name: '张江（科创）分中心' },
        { id: 40, name: '保税区分中心' },
        { id: 62, name: '临港新片区分中心' },
      ],
      model: { guid: '', deptId: '', deptName: '' },
      rules: {
        applicationNos: [
          {
            // 姓名校验规则
            required: true,
            message: '申请编号必须填写',
            trigger: 'blur',
          },
          {
            min: 6,
            message: '申请编号至少输入6位',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.model.guid = this.$route.query.guid
    this.model.deptId = this.$route.query.deptId
    if (!this.model.guid) {
      this.$Modal.error({
        title: '提示',
        content: '参数错误',
      })
      return
    }
    if (this.model.deptId) {
      this.model.deptName = this.dept.find((item) => item.id == this.model.deptId).name
    }
  },
  methods: {
    async refreshCaptcha() {
      try {
        const data = await uni.$u.http.get('/PRRCWxApp/GetLeaveMsgCode', {
          custom: {
            useUrl: true, // 使用 store.state.url
          },
        })
        console.log(data)
        this.captchaImage = data.result.dataBase //
        this.model.verifyCodeGuid = data.result.guid //
      } catch (e) {
        this.$Message.error('验证码获取失败')
      }
    },

    async submit() {
      // 提交前添加验证码校验逻辑
      let _this = this
      this.$refs['Form'].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.showPageLoading = true
        try {
          let { data } = await this.$Ajax.post('/wx/SaveWGRYSReminderApplicationNos', this.model)
          console.log(data)
          if (data.success) {
            this.successShow = true
          } else {
            this.$Modal.error({
              title: '提交失败',
              content: data.message,
            })
          }
        } catch (e) {
          this.$Message.error('提交失败')
        } finally {
          this.showPageLoading = false
        }
      })
    },
    openPage(url) {},
  },
}
</script>

<style lang="less" scoped>
body {
  background-color: #fff !important;
}
.page {
  padding: 0px;
  background-color: #fff !important;
  height: 100vh;
}

.topBg {
  min-height: 70px;
  border-radius: 0px;
  background: linear-gradient(to bottom, #cae0f6, #ffffff);
  padding: 30px 20px;
  // position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;

  img {
    width: 270px;
    height: 60px;
    padding: 10px 0px;
  }

  .info {
    background-color: #fff;
    padding: 20px;
    // position: absolute;
    // width: 310px;
    margin-top: 20px;
    display: flex;
    box-shadow: #abbed0 1px 1px 12px;
    border-radius: 5px;
    font-size: 15px;

    .title {
      display: flex;
      margin-bottom: 5px;
      font-weight: bold;
      color: #2f3845;
      font-size: 15px;

      text {
        margin-left: 3px;
      }
    }

    .content {
      margin-left: 10px;
    }

    .description {
      color: #5b697f;
      font-size: 14px;
      white-space: pre-line;
      text-indent: 2rem;
    }
  }
}

.form {
  .cardCenter {
    .tips {
      padding-top: 10px;
      color: #bfbfbf;
      // background-color: #f5f6f7;
      padding: 10px;
      text-align: center;
      font-size: 13px;
      margin-top: 20px;
    }

    padding: 0px 20px;

    .verification-container {
      display: flex;
      align-items: center;
      margin-bottom: 10px; // 单位统一为px

      .verification-input {
        width: 100px;
        margin-right: 10px;
      }

      .captcha {
        width: 90px;
        height: 32px;
        border: 1px solid #dadbde;
        border-radius: 4px;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }

  .btn_ {
    // position: absolute;
    width: 100%;
    margin-top: 20px;
    // bottom: 40px;
  }
}
.copy {
  padding: 10px 20px 20px;
  font-size: 14px;
  border-top: 1px solid #838383;
  color: #3a3a3a;
  position: absolute;
  background-color: #fff;
  bottom: 0;
  width: 100%;
}

.success {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;

  .success_content {
    text-align: center;
    padding: 80px 20px;
    background-color: #fff;
    // max-width: 300px;
    width: 100%;
    height: 100%;
    .success_icon {
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
    }

    .success_content_title {
      margin-bottom: 15px;

      span {
        font-size: 24px;
        font-weight: 600;
        color: #52c41a;
        letter-spacing: 1px;
      }
    }

    .success_content_desc {
      span {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
      }
    }
  }
}
</style>
